const internals = {};

internals.buildFields = () => ([
    {
        type: 'TextField',
        name: 'email',
        label: 'Email'
    },
    {
        type: 'TextField',
        name: 'schoolId',
        label: 'School'
    }
]);

module.exports.buildFormConfig = function buildFormConfig(props) {

    const {
        defaults,
        onSubmit
    } = props;

    return {
        onSubmit,
        defaults,
        fields: internals.buildFields()
    };
};

module.exports.internals = internals;
